import React from 'react';

import {Loading} from '../styled_components';

let Loader = () => {
  return (
    <Loading>Embedding...</Loading>
  );
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loading.js